import bankApi from '@/api/bankApi'

const SET_MERCHANT_LIST = 'setMerchantList'
const SET_MERCHANT_COUNT = 'setMerchantCount'

const SET_SPLIT_ACCOUNT_LIST = 'setSplitAccountList'
const SET_SPLIT_ACCOUNT_COUNT = 'setSplitAccountCount'

const state = {
  merchantList: [],
  merchantCount: 0,

  splitAccountList: [],
  splitAccountCount: 0
}

const mutations = {
  [SET_MERCHANT_LIST] (state, merchantList) {
    state.merchantList = merchantList
  },
  [SET_MERCHANT_COUNT] (state, merchantCount) {
    state.merchantCount = merchantCount
  },
  [SET_SPLIT_ACCOUNT_LIST] (state, splitAccountList) {
    state.splitAccountList = splitAccountList
  },
  [SET_SPLIT_ACCOUNT_COUNT] (state, splitAccountCount) {
    state.splitAccountCount = splitAccountCount
  }
}

const actions = {
  getMerchants ({ commit }, data) {
    return new Promise((resolve, reject) => {
      bankApi.getMerchants(data.page, data.pageSize,
        data.sort, data.filters).then(res => {
        if (res && res.rcode === 0) {
          commit(SET_MERCHANT_LIST, res.data.merchants)
          commit(SET_MERCHANT_COUNT, res.data.count)
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  async updateMerchantInfo ({ commit }, data) {
    try {
      return await bankApi.updateMerchantInfo(
        data.merchantId, data.corpName, data.name, data.address,
        data.acctName, data.acctNo, data.certNo, data.certStartAt,
        data.certExpireAt)
    } catch (err) {
      return err
    }
  },
  async updateMerchantPayInfo ({ commit }, data) {
    try {
      return await bankApi.updateMerchantPayInfo(data.merchantId, data.nowPayChannel, data.jdReview, data.sbReview)
    } catch (err) {
      return err
    }
  },
  async updateMerchantInfoWithImg ({ commit }, data) {
    try {
      return await bankApi.updateMerchantInfoWithImg(data)
    } catch (err) {
      return err
    }
  },
  completeMerchantInfo ({ commit }, data) {
    return new Promise((resolve, reject) => {
      bankApi.completeMerchantInfo(
        data.merchantId, data.hetong, data.mendian,
        data.shinei, data.shouyintai).then(res => {
        if (res && res.rcode === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  async reReviewMerchantInfo ({ commit }, data) {
    try {
      return await bankApi.reReviewMerchantInfo(data.merchantId, data.jd, data.sb)
    } catch (err) {
      return err
    }
  },
  getIdcardImg ({ commit }, data) {
    return new Promise((resolve, reject) => {
      bankApi.getIdcardImg(data.merchantId).then(res => {
        if (res && res.rcode === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  async getSplitAccounts ({ commit }, data) {
    try {
      const res = await bankApi.getSplitAccounts(data.page, data.pageSize, data.sort, data.filters)
      if (res && res.rcode === 0) {
        commit(SET_SPLIT_ACCOUNT_LIST, res.data.split_accounts)
        commit(SET_SPLIT_ACCOUNT_COUNT, res.data.count)
      }
      return res
    } catch (err) {
      return err
    }
  },
  async passSplitAccount ({ commit }, data) {
    try {
      return await bankApi.passSplitAccount(data.splitAccountId, data.status, data.applyRule)
    } catch (err) {
      return err
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bank.js